import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SERVICES = ["Webdesign", "Google Ads", "SEO", "Branding", "Alles"];

export default function ContactForm({ className = "", redirectTo = null }) {
  const [form, setForm] = useState({ name: "", email: "", company: "", budget: "", message: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Bitte Name, E-Mail und Nachricht ausfüllen.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      if (redirectTo) {
        navigate(redirectTo);
      } else {
        toast.success("Danke! Wir melden uns innerhalb von 24 Stunden.");
        setForm({ name: "", email: "", company: "", budget: "", message: "" });
      }
    } catch (err) {
      toast.error("Etwas ist schiefgelaufen. Bitte erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-lg border border-black/10 bg-[#f7f5f0] px-5 py-4 text-ink placeholder:text-[#a39d90] outline-none transition-colors focus:border-transparent focus:ring-2 focus:ring-[#2c3bff]";

  return (
    <form onSubmit={submit} data-testid="contact-form" className={className}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <input
          data-testid="contact-name-input"
          className={inputCls}
          placeholder="Name *"
          value={form.name}
          onChange={update("name")}
        />
        <input
          data-testid="contact-email-input"
          type="email"
          className={inputCls}
          placeholder="E-Mail *"
          value={form.email}
          onChange={update("email")}
        />
      </div>
      <input
        data-testid="contact-company-input"
        className={`${inputCls} mt-4`}
        placeholder="Unternehmen"
        value={form.company}
        onChange={update("company")}
      />

      <p className="mb-2 mt-6 font-mono text-xs uppercase tracking-wider text-[#8a857b]">
        Wobei können wir helfen?
      </p>
      <div className="flex flex-wrap gap-2">
        {SERVICES.map((b) => (
          <button
            key={b}
            type="button"
            data-testid={`service-pill-${b}`}
            onClick={() => setForm((f) => ({ ...f, budget: b }))}
            className={`rounded-full border px-4 py-2 font-mono text-xs uppercase tracking-wider transition-colors ${
              form.budget === b
                ? "border-[#2c3bff] bg-[#2c3bff] text-white"
                : "border-black/15 text-[#4a453d] hover:border-black/40"
            }`}
          >
            {b}
          </button>
        ))}
      </div>

      <textarea
        data-testid="contact-message-input"
        className={`${inputCls} mt-6 min-h-[130px] resize-none`}
        placeholder="Erzähl uns von deinem Projekt *"
        value={form.message}
        onChange={update("message")}
      />

      <button
        type="submit"
        data-testid="contact-submit-button"
        disabled={loading}
        className="btn-fill mt-5 flex w-full items-center justify-center gap-3 rounded-full bg-[#2c3bff] py-4 font-display text-sm uppercase tracking-wide text-white disabled:opacity-60"
      >
        {loading ? (
          <Loader2 className="h-5 w-5 animate-spin" />
        ) : (
          <>
            Kostenloses Angebot anfordern
            <ArrowRight className="h-4 w-4" />
          </>
        )}
      </button>
    </form>
  );
}
